module.exports = "/assets/data/c827ae94fa8cb2fc6990ee319aae2c23-DL14.data.json";